import { render, staticRenderFns } from "./ThumbnailAction.vue?vue&type=template&id=1f5bf450"
import script from "./ThumbnailAction.vue?vue&type=script&lang=js"
export * from "./ThumbnailAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports